import * as _ from "lodash";

import { Node } from "../Node";
import { _toThreeComplex, _toThreeValuePromise, AbstractProperty } from "./AbstractProperty";
import { json } from "../../global";
import { Color } from "three";

export class PColor extends AbstractProperty<string, Node> {
  constructor(args) {
    super({
      type: "Color",
      default: null,
      ...args,
    });
  }

  typeCheck(value: string): boolean {
    return _.isString(value) && /^#(?:[0-9a-fA-F]{3}){1,2}$/.test(value);
  }

  toJSON(): json {
    return _.clone(this.get()) as any;
  }

  fromJSON(json: json): this {
    this.set(json[this.name]);
    return this;
  }

  toThree(instance: any) {
    _toThreeComplex(
      this,
      instance,
      "Color",
      (instance, value) => _toThreeValuePromise(new Color()),
      (instance, value, instanceValue, freshlyCreated) => instanceValue.set(value),
    );
  }

  threeToInternalFormat(value: Color): string {
    return value == null ? null : "#" + value.getHexString();
  }
}
